<style scoped>
.box{
  min-height: 100vh;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
}
#myChart{
  width: 6rem;
  height: 6rem;
}
.title{
  font-size: .3rem;
  color: #010101;
  text-align: left;
  width: 6.9rem;
  margin-bottom: .3rem;
}
.img{
  width: 6.79rem;
  height: 2.66rem;
  background: url("~assets/lct.png") no-repeat center/cover;
}
.pic{
  width: 7.5rem;
  height: 3rem;
  background: url("~assets/pic.jpg") no-repeat center/cover;
  margin: .24rem 0;
}
ul{
  padding: 0 .24rem .3rem;
}
li{
  margin-bottom: .2rem;
}
img{
  width: 100%;
  height: 100%;
}
</style>
<template>
  <div class="box">
<!--    <img v-if="index==1" src="~assets/p1.jpg" alt="">-->
<!--    <img v-if="index==2" src="~assets/p2.jpg" alt="">-->
<!--    <img v-if="index==3" src="~assets/p3.jpg" alt="">-->
<!--    <img v-if="index==4" src="~assets/p4.jpg" alt="">-->
<!--    <img v-if="index==5" src="~assets/p5.jpg" alt="">-->
  </div>
</template>
<script>
import {getSource, getSources} from "../api"
import echarts from 'echarts'
import noMoreData from 'components/no-more-data'
import newsTopBox from 'components/newsTopBox'
import topbar from 'components/topbar'
import moment from 'moment/moment'
import footerBox from 'components/footer'
import {Swiper, Slide} from 'vue-swiper-component';

let components = {
  noMoreData,
  topbar,
  Swiper,
  Slide,
  footerBox,
  newsTopBox
};
export default {
  data() {
    return {
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
      EnvUrl: `https://cdn.ysqingxin.com/`,
      index:1
    }
  },
  components: components,
  filters: {
    time(value) {
      let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
      return transTime
    },
  },
  computed: {},
  methods: {
    to(n) {
      this.$router.push(`/informationDetail`)
    },
    async getScaleBannerList() {
      let data = await getSources("/bear-scale/api/micro/getMicroBannerList.json",{});
      if (data.status === 0) {
        this.microBannerList = data.microBannerList
      }else{
        alert(data.msg)
      }
    },
  },
  destroyed(){
  },
  mounted() {
    this.index=this.$route.query.index
  }
}
</script>



// WEBPACK FOOTER //
// src/components/informationWord.vue?39f0a870